export default function throwGTMEvent(gtm_event, event_params = {}) {
  if (!window.dataLayer) {
    console.error("PANIC! Data Layer is not define!");
    return false;
  }

  let event_object = Object.assign({}, { event: gtm_event }, event_params);

  window.dataLayer.push(event_object);
}
